var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('query-table',{attrs:{"columnsFormatData":_vm.columnsFormatData,"askData":_vm.askData,"refreshData":_vm.update_count,"uri_name":"/auth_interface","main_width":"1280"}})}
var staticRenderFns = []

export { render, staticRenderFns }